import { render, staticRenderFns } from "./EventBaseData.vue?vue&type=template&id=21e5784e"
import script from "./EventBaseData.js?vue&type=script&lang=js&external"
export * from "./EventBaseData.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports